import {ReactNode, useState} from "react";

import {Button} from "@/components/button/Button.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

import styles from "./FeatureTabs.module.scss";

interface FeatureTab {
  name: string;
  icon: ReactNode;
  title: string;
  description: string;
  feature: ReactNode;
}

interface FeatureTabsProps {
  tabs: FeatureTab[];
}

export const FeatureTabs = ({tabs}: FeatureTabsProps) => {
  const [tab, setTab] = useState(0);

  return (
    <div className={styles.container}>
      <div className={styles.featureTabs}>
        <NavTabs
          variant="marketing"
          items={tabs.map((tab) => ({
            id: tab.name,
            title: tab.name,
          }))}
          selectedId={tabs[tab].name}
          selectTab={(tabName) => {
            setTab(tabs.findIndex(({name}) => name === tabName));
          }}
        />
        <div className={styles.featureContainer}>
          <div>
            <div className={styles.icon}>{tabs[tab].icon}</div>
            <div className={styles.title}>{tabs[tab].title}</div>
            <div className={styles.description}>{tabs[tab].description}</div>
            <div className={styles.button}>
              <Button
                variant="marketingPrimary"
                size="marketingLarge"
                as={"a"}
                href={URL_ORIGINAL_WEBSITE + "/accounts/register"}
              >
                Get Started
              </Button>
            </div>
          </div>
          <div className={styles.feature}>{tabs[tab].feature}</div>
        </div>
      </div>
    </div>
  );
};
